import styled from 'styled-components';
import { palette } from '../../theme/colors';
import { Button } from '../Button/Button';

export const DrawerWrapper = styled.div`
  .profileDrawer {
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1001;
    @media (min-width: 450px) {
      max-width: 26rem;
      margin: auto;
    }
    background-color: ${palette.prussianBlue2};
  }
  .profileDrawer__backdrop {
    z-index: 1000;
  }
  .profileDrawer__handle-wrapper {
    padding: 0;
  }
  .profileDrawer__handle {
    width: 36%;
    margin-top: 1.3125rem;
  }
  .profileDrawer__content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid ${palette.gold};
  background-color: ${palette.goldWithZeroPointFifteenOpacity};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Title = styled.p`
  color: ${palette.white};
  font-family: 'Roboto-Bold';
  font-size: 18px;
  line-height: 24px;
  margin: 0;
`;

export const Body = styled.p`
  color: ${palette.white};
  font-family: 'Roboto-Regular';
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const OkButton = styled(Button)`
  margin-top: 0.5rem;

  button {
    background-color: ${palette.gold};
    color: ${palette.raisinBlack3};
    border-radius: 16px;
    padding: 16px;
    font-family: 'Roboto-Bold';
    font-size: 15px;
    line-height: 20px;
  }
`;
